import React from 'react';
import { useSelector } from 'react-redux';
import format from 'date-fns/format';
import { Table, TableMobile, Icons } from '@components';
import { mdiCurrencyUsd, mdiCalendarRange } from '@mdi/js';

export const ResultadoConjugado = ({
  PercentualRCM,
  ResultadoSimulacao,
  PercentualSaldoVitalicio,
  PercentualRendaMensal,
}) => {
  const user = useSelector((state) => state.user);
  const custom = useSelector((state) => state.configs.tema);

  return (
    <>
      <div className="row">
        <div className="col-12 col-md-6 col-lg-4">
          <div className="card h-100">
            <div className="card-body">
              <Icons
                path={mdiCalendarRange}
                color={custom.codCorLaranja}
                alt="File Icon"
                size={2}
              />
              <p className="text-muted ts-14 mt-2">Idade atual</p>
              <h1 className="ts-20 fw-bold">
                {`${user.dadosPessoais.idade} anos`}
              </h1>
              <p className="text-muted ts-14 mt-2">Data base para cálculo</p>
              <h1 className="ts-20 fw-bold">
                {format(new Date(), 'dd/MM/yyyy')}
              </h1>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4">
          <div className="card h-100">
            <div className="card-body">
              <Icons
                path={mdiCurrencyUsd}
                color={custom.codCorLaranja}
                alt="File Icon"
                size={2}
              />
              <h3 className="text-orange text-muted fw-bold">Saldo</h3>
              <p className="text-muted ts-14 mt-2">Saldo acumulado</p>
              <h1 className="ts-20 fw-bold">
                {`R$ ${ResultadoSimulacao.ValorSaldoContaTotalProjetado}`}
              </h1>
              <p className="text-muted mt-2 ts-14">Percentual do saldo</p>
              <h1 className="ts-20 fw-bold">
                {`${PercentualSaldoVitalicio}%`}
              </h1>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4">
          <div className="card h-100">
            <div className="card-body">
              <Icons
                path={mdiCurrencyUsd}
                color={custom.codCorLaranja}
                alt="File Icon"
                size={2}
              />
              <h3 className="text-orange text-muted fw-bold">Renda Variável</h3>
              <p className="text-muted ts-14 mt-2">
                Saldo a converter em renda variável
              </p>
              <h1 className="ts-20 fw-bold">
                {`R$ ${ResultadoSimulacao.ValorSaldoContasRendaPerc}`}
              </h1>
              <p className="text-muted mt-2 ts-14">
                % saldo a converter em renda variável
              </p>
              <h1 className="ts-20 fw-bold">
                {`${100 - parseInt(PercentualSaldoVitalicio, 10)}%`}
              </h1>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4">
          <div className="card h-100">
            <div className="card-body">
              <Icons
                path={mdiCurrencyUsd}
                color={custom.codCorLaranja}
                alt="File Icon"
                size={2}
              />
              <h3 className="text-orange text-muted fw-bold">Parcela Mensal</h3>
              <p className="text-muted ts-14 mt-2">Valor da parcela</p>
              <h1 className="ts-20 fw-bold">
                {`R$ ${ResultadoSimulacao.ValorBeneficioPerc}`}
              </h1>
              <p className="text-muted mt-2 ts-14">% da parcela mensal</p>
              <h1 className="ts-20 fw-bold">
                {`${Number(PercentualRendaMensal)
                  .toFixed(2)
                  .toString()
                  .replace('.', ',')}%`}
              </h1>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4">
          <div className="card h-100">
            <div className="card-body">
              <Icons
                path={mdiCurrencyUsd}
                color={custom.codCorLaranja}
                alt="File Icon"
                size={2}
              />
              <h3 className="text-orange text-muted fw-bold">
                Renda Vitalícia
              </h3>
              <p className="text-muted ts-14 mt-2">
                Saldo a converter em renda Vitalícia
              </p>
              <h1 className="ts-20 fw-bold">
                {`R$ ${ResultadoSimulacao.ValorSaldocContasRendaVit}`}
              </h1>
              <p className="text-muted mt-2 ts-14">
                % a converter em renda Vitalícia
              </p>
              <h1 className="ts-20 fw-bold">
                {`${PercentualSaldoVitalicio}%`}
              </h1>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4">
          <div className="card h-100">
            <div className="card-body">
              <Icons
                path={mdiCurrencyUsd}
                color={custom.codCorLaranja}
                alt="File Icon"
                size={2}
              />
              <h3 className="text-orange text-muted fw-bold">
                Parcela Vitalícia - RCM
              </h3>
              <p className="text-muted ts-14 mt-2">Parcela vitalícia 0% RCM</p>
              <h1 className="ts-20 fw-bold">
                {`R$ ${ResultadoSimulacao.ValorBeneficio}`}
              </h1>
              <p className="text-muted mt-2 ts-14">
                Parcela vitalícia {`${PercentualRCM} %`} RCM
              </p>
              <h1 className="ts-20 fw-bold">
                {`R$ ${ResultadoSimulacao.ValorBeneficioRcm}`}
              </h1>
            </div>
          </div>
        </div>
      </div>

      <Table
        className="is-desktop mb-32 mt-32"
        odd
        columns={[
          'Renda total sem reversão para pensão',
          'Percentual RCM',
          'Renda total com reversão para pensão',
        ]}
      >
        <tr>
          <td className="ts-14">
            {`R$ ${ResultadoSimulacao.ValorBeneficioTotal}`}
          </td>
          <td className="ts-14">{`${PercentualRCM} %`}</td>
          <td className="ts-14">
            {`R$ ${ResultadoSimulacao.ValorBeneficioTotalRCM}`}
          </td>
        </tr>
      </Table>
      <TableMobile className="mb-32">
        <div className="col-6">
          <div className="thead">Renda total sem reversão para pensão</div>
          <div className="td">{`R$ ${ResultadoSimulacao.ValorBeneficioTotal}`}</div>
        </div>
        <div className="col-6">
          <div className="thead">Percentual RCM</div>
          <div className="td">{PercentualRCM}</div>
        </div>
        <div className="col-6">
          <div className="thead">Renda total com reversão para pensão</div>
          <div className="td">{`R$ ${ResultadoSimulacao.ValorBeneficioTotalRCM}`}</div>
        </div>
      </TableMobile>
    </>
  );
};
